import { Col, Row, Select } from "antd";
import { Option } from "antd/es/mentions";
import { useTranslation } from "react-i18next";
import InputText from "../Input/InputText";
import EditorText from "../EditorText";
import "../../../assets/style/modalStyle/postNews.scss";
import LabelInput from "../LabelInput";
import { DatePicker } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { pupSelector } from "../../../services/selector/index.";
import { deleteGroupTime } from "../../../services/slice/DealSlice";
import { useDispatch } from "react-redux";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import UpImageEdit from "../Button/UpImageEdit";
import { useState } from "react";
import { useEffect } from "react";
import TranslateText from "../TranslateText";
import ModalDelete from "../Modal/delete/ModalDelete";
import ModalSelectGroupCustomer from "../Modal/other/ModalSelectGroupCustomer";
import { IconEdit, IconPen } from "../../../assets/icon";
const dateFormat = "YYYY-MM-DD HH:mm:ss";

const TabAddGroupNotification = ({
  datapost,
  setDataPost,
  setImage,
  error,
  img,
  addPost,
}) => {
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showSelectGroup, setShowSelectGroup] = useState(false);
  const [valueSelectUsed, setValueSelectUsed] = useState([]);
  const [valueSelectValid, setValueSelectValid] = useState([]);
  const [valueSelectExpired, setValueSelectExpired] = useState([]);
  const [valueSelectNumberMachine, setValueSelectNumberMachine] = useState([]);
  const [valueSelectListCard, setValueSelectListCard] = useState([]); //danh sách thẻ 

  useEffect(() => {
    let arrUse = [];
    let arrValid = [];
    let arrExpired = [];
    let arrNumberMachine = [];
    let excelCardList = {}
    if (datapost?.attractGroupDetail?.length) {
      datapost?.attractGroupDetail.forEach((item) => {
        //thử dùng forEach
        if (item.typeGroup === 1) {
          arrUse.push(item.id);
        } else if (item.typeGroup === 2) {
          arrValid.push(item.id);
        } else if (item.typeGroup === 3) {
          arrExpired.push(item.id);
        } else if(item.typeGroup === 4){
          arrNumberMachine.push(item.id);
        } else{
          excelCardList.push(5)
        }
        setValueSelectExpired(arrExpired);
        setValueSelectNumberMachine(arrNumberMachine);
        setValueSelectUsed(arrUse);
        setValueSelectValid(arrValid);
        setValueSelectListCard(excelCardList)
      });
    }
  }, [datapost?.attractGroupDetail, datapost?.attractGroupDetail?.length]);

  const handleDelete = () => {
    dispatch(deleteGroupTime(dataDelete.id));
    dispatch(
      setOpenPUDelete({
        stateOpen: false,
        content: "",
        id: "",
      })
    );
  };

  return (
    <>
      {showSelectGroup ? (
        <ModalSelectGroupCustomer
          valueSelectExpired={valueSelectExpired}
          valueSelectNumberMachine={valueSelectNumberMachine}
          setValueSelectExpired={setValueSelectExpired}
          setValueSelectNumberMachine={setValueSelectNumberMachine}
          setValueSelectUsed={setValueSelectUsed}
          setValueSelectValid={setValueSelectValid}
          valueSelectUsed={valueSelectUsed}
          valueSelectValid={valueSelectValid}
          valueSelectListCard={valueSelectListCard}
          setValueSelectListCard={setValueSelectListCard}
          setDataPost={setDataPost}
          open={showSelectGroup}
          setOpen={setShowSelectGroup}
        />
      ) : null}

      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa nhóm"
          title="Xóa nhóm"
          width={680}
        />
      )}
      {/* Tên tin nhắn */}
      <Row align={"middle"}>
        <Col span={3}>
          <LabelInput style={{ textAlign: "left" }} text={"Tiêu đề"} />
        </Col>
        <Col span={21}>
          <InputText
            maxLength={155}
            focus
            key={"inputTitle"}
            text={datapost.title}
            setText={(value) => setDataPost({ ...datapost, title: value })}
            placeholder={"Nhập tiêu đề tin nhắn"}
            typeInput={`${
              !datapost.title && error.isError ? "checkEmptyText" : null
            }`}
          />
        </Col>
      </Row>
      {/* Nội dung tin nhắn */}
      <Row
        style={{
          //   marginBottom: "1.5rem",
          margin: "1.5rem 0",
          display: "flex",
          alignItems: datapost.typePost === 0,
        }}
      >
        <Col span={3}>
          <LabelInput
            style={{ textAlign: "left" }}
            text={
              datapost.typePost === 0 ? "Nội dung tin nhắn" : "Link thông báo"
            }
          />
        </Col>
        <Col span={21}>
          {datapost.typePost === 0 ? (
            <EditorText
              text={datapost.content}
              height={180}
              placeholder={"Nhập nội dung tin nhắn"}
              setText={setDataPost}
              type={`${
                (!datapost.content || datapost.content === "<p><br></p>") &&
                error.isError
                  ? "checkEmptyText"
                  : null
              }`}
            />
          ) : (
            // <div>{datapost.content}</div>
            <InputText
              text={datapost.redirectUrl}
              setText={(value) =>
                setDataPost({ ...datapost, redirectUrl: value })
              }
              placeholder={"URL"}
              typeInput={`${
                (!datapost.redirectUrl && error.isError) ||
                error.msg === "Đường dẫn không hợp lệ"
                  ? "checkEmptyText"
                  : null
              }`}
            />
          )}
          {/* <div>{datapost.content}</div> */}
        </Col>
      </Row>

      {datapost.typePost === 1 ? (
        <Row
          style={{
            margin: "1.5rem 0",
            display: "flex",
            alignItems: datapost.typePost === 0,
          }}
        >
          <Col span={3}>
            <LabelInput style={{ textAlign: "left" }} text={"Tải ảnh"} />
          </Col>
          <Col span={4}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                // justifyContent: "center",
                width: "200px",
                alignItems: "center",
                marginLeft: 4,
              }}
            >
              <UpImageEdit
                setImage={setImage}
                width={"210px"}
                height={"180px"}
                accept={".png, .jpg, .jpeg, .gif"}
                image={img}
                setDataPost={setDataPost}
                widthImage={623}
                heightImage={500}
                url={`api/image/resources/${datapost.firstImage}`}
                // url={`api/image/resources/${datapost.firstImage}`}
                setFile={(value) => {
                  setDataPost({ ...datapost, firstImage: value });
                }}
                style={
                  addPost && !img && error.isError
                    ? { border: "1px solid red" }
                    : null
                }
              />
              <span className="noteSize">
                <TranslateText text={" Dung lượng ảnh nhỏ hơn 2MB."} />
              </span>
            </div>
          </Col>
        </Row>
      ) : null}

      {/* Đặt lịch gửi */}
      <Row
        style={{ margin: "1.5rem 0", display: "flex", alignItems: "center" }}
      >
        <Col span={3}>
          <LabelInput
            style={{ textAlign: "left" }}
            text={"Đặt lịch gửi"}
          ></LabelInput>
        </Col>
        <Col span={21}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={13}>
              <Row style={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Col span={6}>
                  <LabelInput
                    text={"Thời gian bắt đầu"}
                    style={{ textAlign: "start" }}
                  />
                </Col>
                <Col span={17}>
                  <DatePicker
                    format={"DD/MM/YYYY HH:mm:59"}
                    // value={datapost.timeEnd}
                    placeholder={t("Chọn thời gian")}
                    defaultValue={
                      datapost.timeStart
                        ? moment(datapost.timeStart, dateFormat)
                        : null
                    }
                    style={
                      (!datapost.timeStart ||
                        error.msg ===
                          "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    showTime
                    onChange={(value, date) => {
                      setDataPost({
                        ...datapost,
                        timeStart: value.format("YYYY-MM-DD HH:mm:ss"),
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={11}>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Col span={10}>
                  <LabelInput text={"Đối tượng hiển thị"} />
                </Col>
                <Col span={14}>
                  <Select
                    className="base"
                    style={
                      error.msg ===
                        "Nhóm khách hàng nhận ưu đãi không xác định" &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    defaultValue={0}
                    value={datapost.typePreferential}
                    onChange={(value) => {
                      if (value === 0) {
                        setValueSelectUsed([]);
                        setValueSelectValid([]);
                        return setDataPost({
                          ...datapost,
                          attractGroup: [],
                          typePreferential: value,
                        });
                      }
                      setDataPost({ ...datapost, typePreferential: value });
                    }}
                  >
                    <Option value={0}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                      >
                        Toàn bộ KH
                      </span>
                    </Option>
                    <Option value={1}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH thuộc đại lý
                      </span>
                    </Option>
                    <Option value={2}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH Online
                      </span>
                    </Option>
                    <Option value={3}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH Không bản quyền
                      </span>
                    </Option>
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ display: "flex" }}>
        <Col span={3}></Col>
        <Col span={21}>
          <Row style={{ display: "flex" }}>
            <Col span={13}>
              {" "}
              <Row style={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Col span={6}>
                  <LabelInput
                    text={"Thời gian kết thúc"}
                    style={{ textAlign: "start" }}
                  />
                </Col>
                <Col span={17}>
                  <DatePicker
                    format={"DD/MM/YYYY HH:mm:59"}
                    // value={datapost.timeEnd}
                    placeholder={t("Chọn thời gian")}
                    defaultValue={
                      datapost.timeEnd
                        ? moment(datapost.timeEnd, dateFormat)
                        : null
                    }
                    style={
                      (!datapost.timeEnd ||
                        error.msg ===
                          "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    showTime
                    onChange={(value, date) => {
                      setDataPost({
                        ...datapost,
                        timeEnd: value.format("YYYY-MM-DD HH:mm:ss"),
                      });
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={11}>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Col span={10}>
                  <LabelInput text={"Phạm vi hiển thị"} />
                </Col>
                <Col span={14}>
                  <Select
                    className="base"
                    style={
                      error.msg ===
                        "Nhóm khách hàng nhận ưu đãi không xác định" &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    defaultValue={0}
                    value={datapost.displayRange}
                    onChange={(value) => {
                      if (value === 0) {
                        setValueSelectUsed([]);
                        setValueSelectValid([]);
                        return setDataPost({
                          ...datapost,
                          attractGroup: [],
                          displayRange: value,
                        });
                      } else {
                        setShowSelectGroup(true);
                        setDataPost({ ...datapost, displayRange: value });
                      }
                    }}
                  >
                    <Option value={0}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                      >
                        Toàn bộ KH
                      </span>
                    </Option>
                    {datapost.typePreferential !== 3 ? (
                      <Option value={1}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexGrow: 1,
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              width: "100%",
                              display: "flex",
                              overflow: "hidden",
                            }}
                            className="labelSelect"
                          >
                            Nhóm
                          </span>
                          <IconEdit onClick={() => setShowSelectGroup(true)} />
                        </div>
                      </Option>
                    ) : null}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      {error.isError ? (
        <small className="msgError">{t(error.msg)}</small>
      ) : null}
    </>
  );
};

export default TabAddGroupNotification;
